export default __webpack_public_path__ + "static/media/black_lock.cdab2689.svg";